import { useNavigation } from '@react-navigation/native';
import { Button, Headline3, theme } from 'aimo-ui';
import { InfoIcon } from 'components/icons/InfoIcon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyledWrapper } from 'styles/ContainerStyles';
import { UnifiedPermit } from 'types/generatedSchemaTypes';
import { RootNavProps } from 'types/navigation';
import {
  handlePermitNavigation,
  isFailedRecurringPayment,
  isItemSalesOrder,
} from 'utils/permitUtils';

interface PermitActionButtonProps {
  permit: UnifiedPermit;
}

const ResolvePaymentButton: React.FC<PermitActionButtonProps> = ({
  permit,
}) => {
  const { t } = useTranslation();
  const { navigate } = useNavigation<RootNavProps>();

  if (
    !isItemSalesOrder(permit) ||
    permit.paymentState === 'SUCCESS_PAY' ||
    !isFailedRecurringPayment(permit)
  ) {
    return null;
  }

  return (
    <StyledWrapper mb={10}>
      <Button
        testID={'resolve-payment-button'}
        buttonType="secondary"
        size="l"
        iconComponent={InfoIcon}
        onPress={() => handlePermitNavigation(permit, navigate)}>
        <Headline3 color={theme.colors.white}>
          {t('permit.resolvePayment')}
        </Headline3>
      </Button>
    </StyledWrapper>
  );
};

export default ResolvePaymentButton;
